<app-menu></app-menu>
<mat-toolbar color="primary"> Status of dynamic image sets </mat-toolbar>
<div style="margin: auto">
  <mat-card>
    <mat-card-content>
      <mat-card class="mat-elevation-z0 card-padding">
        <form [formGroup]="filterForm">
          <div>
            <mat-label class="col-sm-1">Dynamic Image Set</mat-label>
            <mat-form-field class="col-sm-2">
              <input
                matInput
                class="form-field"
                [formControl]="filenameFilter"
                placeholder="Enter search term"
              />
            </mat-form-field>
            <mat-label class="col-sm-1">Uploaded from - to</mat-label>
            <mat-form-field class="col-sm-2">
              <input
                matInput
                [matDatepicker]="fromDate"
                placeholder="From Date"
                formControlName="fromDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="fromDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #fromDate></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col-sm-2">
              <input
                matInput
                [matDatepicker]="toDate"
                placeholder="To Date"
                formControlName="toDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="toDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #toDate></mat-datepicker>
            </mat-form-field>
            <button mat-raised-button color="accent" (click)="reset()">
              Reset
            </button>
          </div>
        </form>

        <table
          mat-table
          [dataSource]="dataSource"
          multiTemplateDataRows
          matSort
        >
        <ng-container matColumnDef="lastModifiedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Upload</th>
          <td mat-cell *matCellDef="let row">{{ row.lastModifiedDate | date: "medium":"+0200":"de" }}</td>
        </ng-container>
        <ng-container matColumnDef="disId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Dynamic Image Set
          </th>
          <td mat-cell *matCellDef="let row">{{ row.disId }}</td>
        </ng-container>
        <ng-container matColumnDef="lastPreprodPromoteDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            last Promotion to Pre-Prod
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.lastPreprodPromoteDate | date: "medium":"+0200":"de" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="lastProdPromoteDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            last Promotion to Prod
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.lastProdPromoteDate | date: "medium":"+0200":"de" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <mat-icon>{{expandedElement === row ? 'expand_less' : 'expand_more'}}</mat-icon>
          </td>
      </ng-container>

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let element"
              [attr.colspan]="displayedColumns.length"
            >
              <div
                class="example-element-detail"
                [@detailExpand]="
                  element == expandedElement ? 'expanded' : 'collapsed'
                "
              >
                <ng-container *ngIf="element == expandedElement">
                  <app-dynamic-set-details
                    [deploymentSetId]="element.disId"
                  ></app-dynamic-set-details>
                </ng-container>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let element; columns: displayedColumns"
            class="example-element-row"
            [class.example-expanded-row]="expandedElement === element"
            (click)="
              expandedElement = expandedElement === element ? null : element
            "
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: ['expandedDetail']"
            class="example-detail-row"
          ></tr>
        </table>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>
